// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3undn","content":"styles_content__6Ub8j"};